import { useQuery } from 'react-query';
import request from '../../../../helpers/request';
import { getQueryKeys } from '../lib/getQueryKeys';

const getPermits = async (params) => {
  return await request.get(
    '/TransportPermit/transport',
    params,
    'При получении пропусков произошла ошибка'
  );
};

const usePermits = (params, options) => {
  return useQuery(
    getQueryKeys.permits(params),
    () => getPermits(params),
    options
  );
};

export default usePermits;
